import React, { useEffect } from 'react'
import { Box, LinearProgress } from '@material-ui/core'
import { magicLink } from 'actions/authentication'
import { useParams, useHistory } from 'react-router-dom'
import Logo from 'assets/logo.svg'
import LiveEvents from 'assets/live_events.svg'
import useStyles from './styles'
import { useDispatch } from 'react-redux'

const MagicLink = () => {
  const classes = useStyles()

  const dispatch = useDispatch()
  const history = useHistory()

  const { short_code, ...rest } = useParams()
  useEffect(() => {
    dispatch(magicLink(short_code)).then(() => {
      if (rest['0']) {
        history.push(`/${rest['0']}`)
      } else {
        history.push('/events')
      }
    })
  }, [])
  return (
    <Box className={classes.loadingScreen}>
      <LinearProgress className={classes.linearProgress} color="secondary" />
      <img className={classes.logo} src={Logo} alt="Event.Gives" />
      <img className={classes.liveEvents} src={LiveEvents} alt="Event.Gives" />
    </Box>
  )
}

export default MagicLink



// WEBPACK FOOTER //
// ./src/pages/MagicLink/index.jsx